import {
  getPage,
  exportExcel,
  getByLocationDatetime,
  loadTrack,
  loadDailyTrack,
  removeBefore,
  exportSrcExcel,
} from '@/api/locatehistoryserv'

export default {
  state: {
    state_LocateHistory_GetPageResult: null,
    state_LocateHistory_ExportExcelResult: null,
    state_LocateHistory_GetByLocationDatetimeResult: null,
    state_LocateHistory_LoadTrackResult: null,
    state_LocateHistory_LoadDailyTrackResult: null,
    state_LocateHistory_RemoveBeforeResult: null,
    state_LocateHistory_ExportSrcExcelResult: null,
  },
  mutations: {
    SET_LOCATEHISTORY_GETPAGE_RESULT: (state, rst) => {
      state.state_LocateHistory_GetPageResult = rst;
    },
    SET_LOCATEHISTORY_EXPORTEXCEL_RESULT: (state, rst) => {
      state.state_LocateHistory_ExportExcelResult = rst;
    },
    SET_LOCATEHISTORY_GETBYLOCATIONDATETIME_RESULT: (state, rst) => {
      state.state_LocateHistory_GetByLocationDatetimeResult = rst;
    },
    SET_LOCATEHISTORY_LOADTRACK_RESULT: (state, rst) => {
      state.state_LocateHistory_LoadTrackResult = rst;
    },
    SET_LOCATEHISTORY_LOADDAILYTRACK_RESULT: (state, rst) => {
      state.state_LocateHistory_LoadDailyTrackResult = rst;
    },
    SET_LOCATEHISTORY_REMOVEBEFORE_RESULT: (state, rst) => {
      state.state_LocateHistory_RemoveBeforeResult = rst;
    },
    SET_LOCATEHISTORY_EXPORTSRCEXCEL_RESULT: (state, rst) => {
      state.state_LocateHistory_ExportSrcExcelResult = rst;
    },
  },
  actions: {
    LocateHistoryServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_LOCATEHISTORY_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_LOCATEHISTORY_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    LocateHistoryServ_ExportExcel({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        exportExcel(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_LOCATEHISTORY_EXPORTEXCEL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_LOCATEHISTORY_EXPORTEXCEL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    LocateHistoryServ_GetByLocationDatetime({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getByLocationDatetime(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_LOCATEHISTORY_GETBYLOCATIONDATETIME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_LOCATEHISTORY_GETBYLOCATIONDATETIME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    LocateHistoryServ_LoadTrack({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        loadTrack(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_LOCATEHISTORY_LOADTRACK_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_LOCATEHISTORY_LOADTRACK_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    LocateHistoryServ_LoadDailyTrack({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        loadDailyTrack(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_LOCATEHISTORY_LOADDAILYTRACK_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_LOCATEHISTORY_LOADDAILYTRACK_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    LocateHistoryServ_RemoveBefore({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        removeBefore(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_LOCATEHISTORY_REMOVEBEFORE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_LOCATEHISTORY_REMOVEBEFORE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    LocateHistoryServ_ExportSrcExcel({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        exportSrcExcel(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_LOCATEHISTORY_EXPORTSRCEXCEL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_LOCATEHISTORY_EXPORTSRCEXCEL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_LocateHistory_GetPageResult: state => {
      return state.state_LocateHistory_GetPageResult;
    },
    get_LocateHistory_ExportExcelResult: state => {
      return state.state_LocateHistory_ExportExcelResult;
    },
    get_LocateHistory_GetByLocationDatetimeResult: state => {
      return state.state_LocateHistory_GetByLocationDatetimeResult;
    },
    get_LocateHistory_LoadTrackResult: state => {
      return state.state_LocateHistory_LoadTrackResult;
    },
    get_LocateHistory_LoadDailyTrackResult: state => {
      return state.state_LocateHistory_LoadDailyTrackResult;
    },
    get_LocateHistory_RemoveBeforeResult: state => {
      return state.state_LocateHistory_RemoveBeforeResult;
    },
    get_LocateHistory_ExportSrcExcelResult: state => {
      return state.state_LocateHistory_ExportSrcExcelResult;
    },
  }
}